import { render, staticRenderFns } from "./AddPersistentDamageDialog.vue?vue&type=template&id=435afbd6&"
import script from "./AddPersistentDamageDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersistentDamageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports